module.exports = __webpack_public_path__ + "img/Gefahr_durch_elektrischen_Strom.e4cfcfe1.svg";